{
  "accountBlocked": "Hesap engellendi",
  "accountInactive": "Hesap etkin değil",
  "alreadyHaveAccount": "Zaten bir hesabınız var mı?",
  "backToLogin": "Girişe Dön",
  "backupCode": "Yedek Kod",
  "confirmPassword": "Şifreyi Onayla",
  "continue": "Devam Et",
  "createAccount": "Hesap Oluştur",
  "creatingAccount": "Hesap oluşturuluyor...",
  "dontHaveAccount": "Hesabınız yok mu?",
  "email": "E-posta",
  "emailAddress": "E-posta Adresi",
  "emailAlreadyExists": "Bu e-posta zaten kayıtlı",
  "emailNotVerified": "E-posta doğrulanmadı",
  "enter2FACode": "6 haneli doğrulama kodunu girin",
  "forgotPassword": "Şifremi Unuttum",
  "invalid2FACode": "Geçersiz doğrulama kodu",
  "invalidCredentials": "Geçersiz e-posta veya şifre",
  "loggingIn": "Giriş yapılıyor...",
  "login": "Giriş Yap",
  "loginNow": "Şimdi Giriş Yap",
  "loginProtected": "Hesabınız Google Authenticator ile korunmaktadır.",
  "loginRequired": "Fiyat uyarısı oluşturmak için lütfen giriş yapın.",
  "loginSuccessful": "Giriş başarılı",
  "logout": "Çıkış Yap",
  "password": "Şifre",
  "pleaseWait": "Lütfen bekleyin...",
  "rememberMe": "Beni Hatırla",
  "resetPassword": "Şifreyi Sıfırla",
  "sendCode": "Kod Gönder",
  "sending": "Gönderiliyor...",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
  "signup": "Kaydol",
  "signupNow": "Şimdi Kaydol",
  "signupSuccessful": "Hesap başarıyla oluşturuldu",
  "twoFactorAuthentication": "İki Faktörlü Kimlik Doğrulama",
  "verify": "Doğrula",
  "verify2FA": "2FA Doğrula",
  "verifyEmail": "E-postayı Doğrula",
  "verifyResetCode": "Sıfırlama Kodunu Doğrula"
}